export function redirectShipmentPage(isLoggedIn, currentPath) {
  const shipmentCodeStored = localStorage.getItem("shipmentCode");

  if (currentPath === "/envio") {
    localStorage.removeItem("shipmentCode");
    return;
  }

  if (isLoggedIn && currentPath === "/" && shipmentCodeStored) {
    localStorage.removeItem("shipmentCode");
    window.location.href(`/envio?shipmentCode=${shipmentCodeStored}`);
  }
}
